import { gql } from '@apollo/client'

const PASSENGER_PROPERTY_FIELDS = gql`
  fragment PassengerPropertyFields on PassengerProperty {
    id
    name
    countryCode
    enabled
    required
    departureDateRanges {
      endAt
      startAt
    }
    label {
      language
      text
    }
    abbreviation {
      language
      text
    }
    description {
      language
      text
    }
    searchDateRanges {
      endAt
      startAt
    }
    settings {
      discount
      passengerTypes {
        id
        name
      }
      salesChannelsV2 {
        id
        name
      }
    }
  }
`
export const GET_PASSENGER_PROPERTIES = gql`
  query GetPassengerProperties($pagination: Pagination, $input: PassengerPropertiesInput) {
    passengerProperties(pagination: $pagination, input: $input) {
      items {
        ...PassengerPropertyFields
      }
      total
    }
  }
  ${PASSENGER_PROPERTY_FIELDS}
`

export const GET_PASSENGER_PROPERTY = gql`
  query GetPassengerProperty($input: PassengerPropertyInput!) {
    passengerProperty(input: $input) {
      ...PassengerPropertyFields
    }
  }
  ${PASSENGER_PROPERTY_FIELDS}
`

export const GET_PASSENGER_PROPERTIES_AUTOCOMPLETE = gql`
  query GetPassengerPropertiesAutoComplete($input: PassengerPropertiesAutocompleteInput) {
    passengerPropertiesAutocomplete(input: $input) {
      id
      name
    }
  }
`
